import { lazy } from 'react';
import { Route, Routes } from 'react-router';
import { NotFound } from '../../app/routing/NotFound';
import { equipmentPath, sitesFullPath } from '../../pathDefinitions';
import { equipmentIdParam } from '../equipment/routes';

const ListSitesRoute = lazy(() => import('./list/ListSitesRoute'));
const SiteDetailsRoute = lazy(() => import('./details/SiteDetailsRoute'));
const SiteEquipmentDetails = lazy(
  () => import('./details/SiteEquipmentDetails')
);
const SiteCompanyDetails = lazy(() => import('./details/SiteCompanyDetails'));

export const siteEquipmentRoute = (siteId: string, equipmentId: string) =>
  `${sitesFullPath}/${siteId}/${equipmentPath}/${equipmentId}`;

export const siteCompanyRoute = (siteId: string, companyId: string) =>
  `${sitesFullPath}/${siteId}/company/${companyId}`;

export const siteIdParam = 'siteId';
export const companyIdParam = 'companyId';

export default function AdminSiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ListSitesRoute />} />
      <Route path={`:${siteIdParam}`} element={<SiteDetailsRoute />} />
      <Route
        path={`:${siteIdParam}/${equipmentPath}/:${equipmentIdParam}`}
        element={<SiteEquipmentDetails />}
      />
      <Route
        path={`:${siteIdParam}/company/:${companyIdParam}`}
        element={<SiteCompanyDetails />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
